import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  PrismaJson: { input: any; output: any; }
  URL: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  AccountSubscription: AccountSubscription;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isDemoContentReady: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stripeSubscription: Maybe<StripeSubscription>;
  updatedAt: Scalars['Date']['output'];
};

export type AccountSubscription = {
  __typename?: 'AccountSubscription';
  Plan: Plan;
  accountId: Scalars['String']['output'];
  autoTopUpEnabled: Scalars['Boolean']['output'];
  autoTopUpLimit: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  stripeSubscriptionId: Maybe<Scalars['String']['output']>;
};

export type AnalyzePdfRes = {
  __typename?: 'AnalyzePdfRes';
  success: Scalars['Boolean']['output'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['Date']['output'];
  id: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ApiKeysUsagePayload = {
  __typename?: 'ApiKeysUsagePayload';
  _id: Scalars['String']['output'];
  averageEnhancementDuration: Maybe<Scalars['Float']['output']>;
  creditsUsed: Scalars['Int']['output'];
  enhancementsCreated: Scalars['Float']['output'];
  uploadsFinished: Scalars['Float']['output'];
};

export type CancelSubscriptionInput = {
  reason: Scalars['String']['input'];
};

export enum CheckoutPlan {
  BasicPlan_2023V1 = 'BASIC_PLAN_2023_v1',
  BusinessPlan_2022V1 = 'BUSINESS_PLAN_2022_v1'
}

export type ConfirmSignupEmailAddressInput = {
  activationKey: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type ContactSupportInput = {
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  requestsRepresentative: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type CreateCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  currency: InputMaybe<Currency>;
  downgradeReason: InputMaybe<Scalars['String']['input']>;
  plan: CheckoutPlan;
  successUrl: Scalars['String']['input'];
};

export type CreateCheckoutSessionPayload = {
  __typename?: 'CreateCheckoutSessionPayload';
  url: Scalars['String']['output'];
};

export type CreateEnhancedImageInput = {
  artifactsDetectionRemoval: InputMaybe<EnhancedImageParametersArtifactsDetectionRemoval>;
  backgroundRemovalBlur: InputMaybe<Scalars['Decimal']['input']>;
  backgroundRemovalMode: InputMaybe<EnhancedImageParametersPortraitBackgroundMode>;
  backgroundRemovalReplaceImageUrl: InputMaybe<Scalars['String']['input']>;
  customColorConfig: InputMaybe<CustomColorConfigInput>;
  /**
   * This will convert to preset: DEFAULT, but remains in the API for backwards compatibility.
   *           This won't do anything if another preset is selected.
   */
  defaultImageEnhancement: InputMaybe<EnhancedImageParametersDefaultImageEnhancement>;
  enhanceFaceDetails: InputMaybe<EnhancedImageParametersEnhanceFaceDetails>;
  /** Options are FULL or PREVIEW (defaults to FULL). If PREVIEW is chosen, a smaller version is enhanced and only customColorConfig is allowed */
  mode: InputMaybe<EnhancedImageEnhancementMode>;
  noiseAdditionProfilingStrength: InputMaybe<Scalars['Decimal']['input']>;
  noiseReductionProfilingMode: InputMaybe<EnhancedImageParametersNoiseReductionProfilingMode>;
  noiseReductionProfilingMonochromeStrength: InputMaybe<Scalars['Decimal']['input']>;
  noiseReductionProfilingStrength: InputMaybe<Scalars['Decimal']['input']>;
  preset: InputMaybe<EnhancedImageParametersPreset>;
  redEyeCorrectionsEyeStrength: InputMaybe<Scalars['Decimal']['input']>;
  redEyeCorrectionsMode: InputMaybe<EnhancedImageParametersRedEyeCorrectionsMode>;
  redEyeCorrectionsStrength: InputMaybe<Scalars['Decimal']['input']>;
  targetResolution: InputMaybe<Scalars['Decimal']['input']>;
  upscalingCustomDPI: InputMaybe<Scalars['Int']['input']>;
  upscalingCustomWidth: InputMaybe<Scalars['Int']['input']>;
  upscalingFactor: InputMaybe<EnhancedImageParametersUpscalingFactor>;
  upscalingThreshold: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateExportPayload = {
  __typename?: 'CreateExportPayload';
  downloadUrl: Maybe<Scalars['String']['output']>;
  enhancedImagesCount: Scalars['Int']['output'];
  exportCreatedAsync: Scalars['Boolean']['output'];
  filename: Maybe<Scalars['String']['output']>;
  unEnhancedImagesCount: Scalars['Int']['output'];
};

export type CreateFolderInput = {
  fileType: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentFolderId: InputMaybe<Scalars['String']['input']>;
};

export type CreatePortalSessionInput = {
  returnUrl: Scalars['String']['input'];
};

export type CreatePortalSessionPayload = {
  __typename?: 'CreatePortalSessionPayload';
  url: Scalars['String']['output'];
};

export type CreateSignedUploadUrlInput = {
  filename: Scalars['String']['input'];
  filesize: Scalars['Int']['input'];
  folderId: InputMaybe<Scalars['String']['input']>;
  mimetype: Scalars['String']['input'];
};

export type CreateSignedUploadUrlPayload = {
  __typename?: 'CreateSignedUploadUrlPayload';
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type CreateUploadFromUrlInput = {
  folderId: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateWebhookInput = {
  url: Scalars['String']['input'];
};

export type CreditsPayload = {
  __typename?: 'CreditsPayload';
  id: Scalars['String']['output'];
  periodEnd: Maybe<Scalars['Date']['output']>;
  periodStart: Scalars['Date']['output'];
  remainingCreditsThisPeriod: Maybe<Scalars['Int']['output']>;
  totalCreditsInThisPeriod: Scalars['Int']['output'];
  usedCreditsThisPeriod: Scalars['Int']['output'];
  usedTopUps: Maybe<Scalars['Int']['output']>;
};

export enum Currency {
  Eur = 'EUR',
  Usd = 'USD'
}

export type CustomColorConfigFaceCorrectionsInput = {
  /** (min: 0.00, max: 1.00, default: 0.00) */
  adaptiveFaceFlash: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  faceDetectionStrength: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.00) */
  skinToneRecovery: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigGlobalCorrectionsInput = {
  /** (min: 0.00, max: 1.00, default: 0.50) */
  brightness: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  color: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0) */
  sharpening: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigInput = {
  faceCorrections: InputMaybe<CustomColorConfigFaceCorrectionsInput>;
  globalCorrections: InputMaybe<CustomColorConfigGlobalCorrectionsInput>;
  localCorrections: InputMaybe<CustomColorConfigLocalCorrectionsInput>;
  localSkinCorrections: InputMaybe<CustomColorConfigLocalSkinCorrectionsInput>;
  localSkyCorrections: InputMaybe<CustomColorConfigLocalSkyCorrectionsInput>;
  localVegetationCorrections: InputMaybe<CustomColorConfigLocalVegetationCorrectionsInput>;
  manualCorrections: InputMaybe<CustomColorConfigManualCorrectionsInput>;
  noiseAddition: InputMaybe<CustomColorConfigNoiseAdditionInput>;
  noiseReduction: InputMaybe<CustomColorConfigNoiseReductionInput>;
  redEyeCorrections: InputMaybe<CustomColorConfigRedEyeCorrectionsInput>;
};

export type CustomColorConfigLocalCorrectionsInput = {
  /** (min: 0.00, max: 1.00, default: 0.50) */
  color: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  highlights: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  shadows: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  sharpening: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigLocalSkinCorrectionsInput = {
  /** (min: -1.00, max: 1.00, default: 0.00) */
  brightness: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  contrast: InputMaybe<Scalars['Float']['input']>;
  /** (min: -10.00, max: 10.00, default: 0.00) */
  hue: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  saturation: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.00) */
  strength: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigLocalSkyCorrectionsInput = {
  /** (min: -1.00, max: 1.00, default: 0.00) */
  brightness: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  contrast: InputMaybe<Scalars['Float']['input']>;
  /** (min: -10.00, max: 10.00, default: 0.00) */
  hue: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  saturation: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.00) */
  strength: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigLocalVegetationCorrectionsInput = {
  /** (min: -1.00, max: 1.00, default: 0.00) */
  brightness: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  contrast: InputMaybe<Scalars['Float']['input']>;
  /** (min: -10.00, max: 10.00, default: 0.00) */
  hue: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  saturation: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.00) */
  strength: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigManualCorrectionsInput = {
  /** (min: -1.00, max: 1.00, default: 0.00) */
  blue: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  brightness: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  contrast: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  green: InputMaybe<Scalars['Float']['input']>;
  /** (min: -1.00, max: 1.00, default: 0.00) */
  red: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.00) */
  shadows: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigNoiseAdditionInput = {
  /** (min: 0.00, max: 1.00, default: 0.50) */
  strength: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigNoiseReductionInput = {
  mode: InputMaybe<NoiseReductionProfilingMode>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  monochromeStrength: InputMaybe<Scalars['Float']['input']>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  strength: InputMaybe<Scalars['Float']['input']>;
};

export type CustomColorConfigRedEyeCorrectionsInput = {
  /** (min: 0.00, max: 1.00, default: 0.50) */
  eyeStrength: InputMaybe<Scalars['Float']['input']>;
  mode: InputMaybe<RedEyeCorrectionsCorrectionsMode>;
  /** (min: 0.00, max: 1.00, default: 0.50) */
  strength: InputMaybe<Scalars['Float']['input']>;
};

export type DeleteMeInput = {
  reason: Scalars['String']['input'];
};

export type DeleteUploadsPayload = {
  __typename?: 'DeleteUploadsPayload';
  deletedUploadIds: Array<Scalars['String']['output']>;
};

export type EnhancedImage = {
  __typename?: 'EnhancedImage';
  EnhancedImageFeedback: Maybe<EnhancedImageFeedback>;
  EnhancedImageParameters: EnhancedImageParameters;
  Upload: Upload;
  Workflow: Maybe<Workflow>;
  duration: Maybe<Scalars['Int']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  filename: Maybe<Scalars['String']['output']>;
  fullUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimetype: Maybe<Scalars['String']['output']>;
  mode: EnhancedImageEnhancementMode;
  originUrl: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['Date']['output']>;
  status: EnhancedImageStatus;
  uploadId: Scalars['ID']['output'];
  viesusDuration: Maybe<Scalars['Int']['output']>;
};

export enum EnhancedImageEnhancementMode {
  Full = 'FULL',
  Preview = 'PREVIEW'
}

export type EnhancedImageFeedback = {
  __typename?: 'EnhancedImageFeedback';
  comment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  score: Scalars['Int']['output'];
};

export type EnhancedImageParameters = {
  __typename?: 'EnhancedImageParameters';
  artifactsDetectionRemoval: Maybe<EnhancedImageParametersArtifactsDetectionRemoval>;
  backgroundRemovalBlur: Maybe<Scalars['Decimal']['output']>;
  backgroundRemovalMode: Maybe<EnhancedImageParametersPortraitBackgroundMode>;
  backgroundRemovalReplaceImageUrl: Maybe<Scalars['String']['output']>;
  customColorConfig: Maybe<Scalars['PrismaJson']['output']>;
  defaultImageEnhancement: Maybe<EnhancedImageParametersDefaultImageEnhancement>;
  enhanceFaceDetails: Maybe<EnhancedImageParametersEnhanceFaceDetails>;
  id: Scalars['ID']['output'];
  noiseAdditionProfilingStrength: Maybe<Scalars['Decimal']['output']>;
  noiseReductionProfilingMode: Maybe<EnhancedImageParametersNoiseReductionProfilingMode>;
  noiseReductionProfilingMonochromeStrength: Maybe<Scalars['Decimal']['output']>;
  noiseReductionProfilingStrength: Maybe<Scalars['Decimal']['output']>;
  preset: Maybe<EnhancedImageParametersPreset>;
  redEyeCorrectionsEyeStrength: Maybe<Scalars['Decimal']['output']>;
  redEyeCorrectionsMode: Maybe<EnhancedImageParametersRedEyeCorrectionsMode>;
  redEyeCorrectionsStrength: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated superResolution is deprecated, use upscalingFactor instead. */
  superResolution: Maybe<EnhancedImageParametersSuperResolution>;
  targetResolution: Maybe<Scalars['Decimal']['output']>;
  upscalingCustomDPI: Maybe<Scalars['Int']['output']>;
  upscalingCustomWidth: Maybe<Scalars['Int']['output']>;
  upscalingFactor: Maybe<EnhancedImageParametersUpscalingFactor>;
  upscalingThreshold: Maybe<Scalars['Decimal']['output']>;
};

export enum EnhancedImageParametersArtifactsDetectionRemoval {
  Auto = 'AUTO',
  Enforce = 'ENFORCE',
  Off = 'OFF',
  On = 'ON'
}

export enum EnhancedImageParametersDefaultImageEnhancement {
  Off = 'OFF',
  On = 'ON'
}

export enum EnhancedImageParametersEnhanceFaceDetails {
  Off = 'OFF',
  On = 'ON'
}

export enum EnhancedImageParametersNoiseReductionProfilingMode {
  Ai = 'AI',
  Dynamic = 'DYNAMIC',
  None = 'NONE'
}

export enum EnhancedImageParametersPortraitBackgroundMode {
  Original = 'ORIGINAL',
  Remove = 'REMOVE',
  Replace = 'REPLACE'
}

export enum EnhancedImageParametersPreset {
  Crisp = 'CRISP',
  Custom = 'CUSTOM',
  DarkShots = 'DARK_SHOTS',
  Default = 'DEFAULT',
  FlashShots = 'FLASH_SHOTS',
  Ice = 'ICE',
  Landscape = 'LANDSCAPE',
  PortraitsEastAsia = 'PORTRAITS_EAST_ASIA',
  PortraitsIndia = 'PORTRAITS_INDIA',
  Warm = 'WARM'
}

export enum EnhancedImageParametersRedEyeCorrectionsMode {
  Extended = 'EXTENDED',
  Safe = 'SAFE'
}

export enum EnhancedImageParametersSuperResolution {
  X2 = 'X2',
  X4 = 'X4',
  X6 = 'X6',
  X8 = 'X8',
  X10 = 'X10'
}

export enum EnhancedImageParametersUpscalingFactor {
  Custom = 'CUSTOM',
  X1 = 'X1',
  X2 = 'X2',
  X3 = 'X3',
  X4 = 'X4',
  X6 = 'X6',
  X8 = 'X8',
  X10 = 'X10'
}

export enum EnhancedImageStatus {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  Error = 'ERROR',
  Finished = 'FINISHED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export type Folder = {
  __typename?: 'Folder';
  InputWorkflowTriggers: Array<WorkflowTrigger>;
  OutputWorkflowTriggers: Array<WorkflowTrigger>;
  ParentFolder: Maybe<Folder>;
  Uploads: Array<Upload>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentFolderId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  uploadsCount: Scalars['Int']['output'];
};

export type FolderBreadcrumbItem = {
  __typename?: 'FolderBreadcrumbItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FoldersFilterInput = {
  fileType: InputMaybe<Scalars['String']['input']>;
  parentFolderId: InputMaybe<Scalars['String']['input']>;
  skipParentFolderCheck: InputMaybe<Scalars['Boolean']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Int']['output'];
  currency: InvoiceCurrency;
  hostedInvoiceUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicePdfUrl: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['Date']['output'];
  number: Maybe<Scalars['String']['output']>;
  periodEndAt: Maybe<Scalars['Date']['output']>;
  periodStartAt: Maybe<Scalars['Date']['output']>;
  status: InvoiceStatus;
  stripeSubscriptionId: Maybe<Scalars['String']['output']>;
};

export enum InvoiceCurrency {
  Chf = 'CHF',
  Eur = 'EUR',
  Usd = 'USD'
}

export enum InvoiceStatus {
  Open = 'OPEN',
  Paid = 'PAID',
  PastDue = 'PAST_DUE',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type InvoicesPagination = {
  cursor: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
};

export type InvoicesPayload = {
  __typename?: 'InvoicesPayload';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Invoice>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  analyzePdf: AnalyzePdfRes;
  cancelEnhancement: Scalars['String']['output'];
  cancelSubscription: Scalars['Boolean']['output'];
  completeSignedUpload: Upload;
  confirmSignupEmailAddress: Scalars['Boolean']['output'];
  contactSupport: Scalars['Boolean']['output'];
  createApiKey: ApiKey;
  createCheckoutSession: CreateCheckoutSessionPayload;
  createEnhancedImage: EnhancedImage;
  createExport: CreateExportPayload;
  createFolder: Folder;
  createPortalSession: CreatePortalSessionPayload;
  createSignedUploadUrl: CreateSignedUploadUrlPayload;
  createUploadFromUrl: Upload;
  createWebhook: Maybe<Webhook>;
  deleteApiKey: Scalars['Boolean']['output'];
  deleteFolder: Scalars['Boolean']['output'];
  deleteMe: Scalars['Boolean']['output'];
  deleteUploads: DeleteUploadsPayload;
  deleteWebhook: Scalars['Boolean']['output'];
  deleteWorkflow: Scalars['Boolean']['output'];
  login: User;
  refreshApiKey: ApiKey;
  requestResetPassword: Scalars['Boolean']['output'];
  resendEmailConfirmation: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  signup: Scalars['Boolean']['output'];
  updateAccountSubscription: AccountSubscription;
  updateEmailAddress: Scalars['Boolean']['output'];
  updateFileRetention: User;
  updateFolder: Folder;
  updatePassword: Scalars['Boolean']['output'];
  updateProfile: User;
  updateWebhook: Webhook;
  updateWorkflowSettings: Workflow;
  upsertEnhancedImageFeedback: Scalars['Boolean']['output'];
  upsertWorkflow: Workflow;
  upsertWorkflowTriggers: Workflow;
};


export type MutationAnalyzePdfArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationCancelEnhancementArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCompleteSignedUploadArgs = {
  id: Scalars['String']['input'];
};


export type MutationConfirmSignupEmailAddressArgs = {
  input: ConfirmSignupEmailAddressInput;
};


export type MutationContactSupportArgs = {
  input: ContactSupportInput;
};


export type MutationCreateApiKeyArgs = {
  label: Scalars['String']['input'];
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreateEnhancedImageArgs = {
  callbackUrl: InputMaybe<Scalars['URL']['input']>;
  input: CreateEnhancedImageInput;
  uploadId: Scalars['String']['input'];
};


export type MutationCreateExportArgs = {
  uploadIds: Array<Scalars['String']['input']>;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreatePortalSessionArgs = {
  input: CreatePortalSessionInput;
};


export type MutationCreateSignedUploadUrlArgs = {
  input: CreateSignedUploadUrlInput;
};


export type MutationCreateUploadFromUrlArgs = {
  input: CreateUploadFromUrlInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFolderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMeArgs = {
  input: DeleteMeInput;
};


export type MutationDeleteUploadsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteWebhookArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkflowArgs = {
  workflowId: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRefreshApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestResetPasswordArgs = {
  input: RequestResetPasswordInput;
};


export type MutationResendEmailConfirmationArgs = {
  input: ResendEmailConfirmationInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationUpdateAccountSubscriptionArgs = {
  input: UpdateAccountSubscriptionInput;
  subscriptionId: Scalars['String']['input'];
};


export type MutationUpdateEmailAddressArgs = {
  input: UpdateEmailAddressInput;
};


export type MutationUpdateFileRetentionArgs = {
  days: Scalars['Int']['input'];
};


export type MutationUpdateFolderArgs = {
  id: Scalars['String']['input'];
  input: UpdateFolderInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateWebhookArgs = {
  id: Scalars['String']['input'];
  input: UpdateWebhookInput;
};


export type MutationUpdateWorkflowSettingsArgs = {
  input: UpsertWorkflowSettingsInput;
  workflowId: Scalars['String']['input'];
};


export type MutationUpsertEnhancedImageFeedbackArgs = {
  enhancedImageId: Scalars['String']['input'];
  input: UpsertEnhancedImageFeedbackInput;
};


export type MutationUpsertWorkflowArgs = {
  input: WorkflowUpsertInput;
};


export type MutationUpsertWorkflowTriggersArgs = {
  input: UpsertWorkflowTriggersInput;
  workflowId: Scalars['String']['input'];
};

export enum NoiseReductionProfilingMode {
  Dynamic = 'DYNAMIC',
  None = 'NONE'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  billing_details: PaymentMethodBillingDetails;
  card: PaymentMethodCard;
  created: Scalars['Int']['output'];
  customer: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  object: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodAddress = {
  __typename?: 'PaymentMethodAddress';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  line1: Maybe<Scalars['String']['output']>;
  line2: Maybe<Scalars['String']['output']>;
  postal_code: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodBillingDetails = {
  __typename?: 'PaymentMethodBillingDetails';
  address: PaymentMethodAddress;
  email: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  brand: Maybe<Scalars['String']['output']>;
  checks: PaymentMethodChecks;
  country: Maybe<Scalars['String']['output']>;
  exp_month: Scalars['Int']['output'];
  exp_year: Scalars['Int']['output'];
  fingerprint: Maybe<Scalars['String']['output']>;
  funding: Maybe<Scalars['String']['output']>;
  generated_from: Maybe<Scalars['String']['output']>;
  last4: Maybe<Scalars['String']['output']>;
  networks: PaymentMethodNetworks;
  three_d_secure_usage: PaymentMethodThreeDSecureUsage;
  wallet: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodChecks = {
  __typename?: 'PaymentMethodChecks';
  address_line1_check: Maybe<Scalars['String']['output']>;
  address_postal_code_check: Maybe<Scalars['String']['output']>;
  cvc_check: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodNetworks = {
  __typename?: 'PaymentMethodNetworks';
  available: Maybe<Scalars['String']['output']>;
  preferred: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodThreeDSecureUsage = {
  __typename?: 'PaymentMethodThreeDSecureUsage';
  supported: Scalars['Boolean']['output'];
};

export type PaymentMethodsPayload = {
  __typename?: 'PaymentMethodsPayload';
  items: Array<PaymentMethod>;
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['ID']['output'];
  monthlyCreditsAmount: Maybe<Scalars['Int']['output']>;
  monthlyPrice: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  topUpPrice: Maybe<Scalars['Float']['output']>;
  topupCreditsAmount: Maybe<Scalars['Int']['output']>;
};


export type PlanMonthlyPriceArgs = {
  currency: InputMaybe<Currency>;
};


export type PlanTopUpPriceArgs = {
  currency: InputMaybe<Currency>;
};

export type Profile = {
  __typename?: 'Profile';
  avatarUrl: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyRole: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  dateOfBirth: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  salutation: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account: Maybe<Account>;
  apiKeys: Array<ApiKey>;
  apiKeysUsage: ApiKeysUsagePayload;
  credits: CreditsPayload;
  enhancedImage: Maybe<EnhancedImage>;
  enhancedImageCompleted: EnhancedImage;
  folder: Maybe<Folder>;
  folderBreadcrumb: Array<FolderBreadcrumbItem>;
  folders: QueryFoldersConnection;
  invoices: InvoicesPayload;
  me: User;
  paymentMethods: PaymentMethodsPayload;
  plans: Array<Plan>;
  tasksList: TasksListPayload;
  upload: Maybe<Upload>;
  uploads: QueryUploadsConnection;
  version: Scalars['String']['output'];
  webhook: Maybe<Webhook>;
  webhookLogs: WebhookLogsPayload;
  webhooks: Array<Webhook>;
  workflow: Maybe<Workflow>;
  workflows: QueryWorkflowsConnection;
};


export type QueryApiKeysUsageArgs = {
  apiKeyId: InputMaybe<Scalars['String']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnhancedImageArgs = {
  id: Scalars['String']['input'];
};


export type QueryEnhancedImageCompletedArgs = {
  id: Scalars['String']['input'];
};


export type QueryFolderArgs = {
  id: Scalars['String']['input'];
};


export type QueryFolderBreadcrumbArgs = {
  id: Scalars['String']['input'];
};


export type QueryFoldersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<FoldersFilterInput>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoicesArgs = {
  pagination: InputMaybe<InvoicesPagination>;
};


export type QueryPlansArgs = {
  currency: InputMaybe<Currency>;
};


export type QueryUploadArgs = {
  id: Scalars['String']['input'];
};


export type QueryUploadsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<UploadsFilterInput>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWebhookArgs = {
  id: Scalars['String']['input'];
};


export type QueryWebhookLogsArgs = {
  filter: InputMaybe<WebhookLogsFilter>;
  webhookId: Scalars['String']['input'];
};


export type QueryWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkflowsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFoldersConnection = {
  __typename?: 'QueryFoldersConnection';
  edges: Array<QueryFoldersConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryFoldersConnectionEdge = {
  __typename?: 'QueryFoldersConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Folder;
};

export type QueryUploadsConnection = {
  __typename?: 'QueryUploadsConnection';
  edges: Array<QueryUploadsConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryUploadsConnectionEdge = {
  __typename?: 'QueryUploadsConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Upload;
};

export type QueryWorkflowsConnection = {
  __typename?: 'QueryWorkflowsConnection';
  edges: Array<QueryWorkflowsConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryWorkflowsConnectionEdge = {
  __typename?: 'QueryWorkflowsConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Workflow;
};

export enum RedEyeCorrectionsCorrectionsMode {
  Extended = 'EXTENDED',
  Safe = 'SAFE'
}

export type RequestResetPasswordInput = {
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResendEmailConfirmationInput = {
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SignupInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  foundViesusThrough: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  preferences: InputMaybe<Scalars['PrismaJson']['input']>;
  secret: Scalars['String']['input'];
  url: InputMaybe<Scalars['String']['input']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  application_fee_percent: Maybe<Scalars['Int']['output']>;
  billing_cycle_anchor: Scalars['Int']['output'];
  cancel_at: Maybe<Scalars['Int']['output']>;
  cancel_at_period_end: Scalars['Boolean']['output'];
  canceled_at: Maybe<Scalars['Int']['output']>;
  collection_method: Maybe<Scalars['String']['output']>;
  created: Scalars['Int']['output'];
  currency: Maybe<Scalars['String']['output']>;
  current_period_end: Scalars['Int']['output'];
  current_period_start: Scalars['Int']['output'];
  customer: Maybe<Scalars['String']['output']>;
  days_until_due: Maybe<Scalars['Int']['output']>;
  default_payment_method: Scalars['String']['output'];
  ended_at: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  latest_invoice: Scalars['String']['output'];
  livemode: Scalars['Boolean']['output'];
  next_pending_invoice_item_invoice: Maybe<Scalars['Int']['output']>;
  object: Maybe<Scalars['String']['output']>;
  schedule: Maybe<Scalars['String']['output']>;
  start_date: Scalars['Int']['output'];
  status: Maybe<Scalars['String']['output']>;
};

export type TasksListPayload = {
  __typename?: 'TasksListPayload';
  _id: Scalars['String']['output'];
  completed: Array<EnhancedImage>;
  hash: Scalars['String']['output'];
  inProgress: Array<EnhancedImage>;
};

export type UpdateAccountSubscriptionInput = {
  autoTopUpEnabled: InputMaybe<Scalars['Boolean']['input']>;
  autoTopUpLimit: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateEmailAddressInput = {
  email: Scalars['String']['input'];
};

export type UpdateFolderInput = {
  name: Scalars['String']['input'];
};

export type UpdatePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type UpdateProfileInput = {
  companyName: InputMaybe<Scalars['String']['input']>;
  companyRole: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: InputMaybe<Scalars['String']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  preferences: InputMaybe<Scalars['PrismaJson']['input']>;
  salutation: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebhookInput = {
  url: Scalars['String']['input'];
};

export type Upload = {
  __typename?: 'Upload';
  EnhancedImages: Array<EnhancedImage>;
  duration: Maybe<Scalars['Int']['output']>;
  extension: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filesize: Maybe<Scalars['Int']['output']>;
  finishedAt: Maybe<Scalars['Date']['output']>;
  folderId: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastSuccesfulEnhancedImage: Maybe<EnhancedImage>;
  lastSuccesfulEnhancedImagePreview: Maybe<EnhancedImage>;
  metadata: Maybe<Scalars['PrismaJson']['output']>;
  mimetype: Scalars['String']['output'];
  originUrl: Maybe<Scalars['String']['output']>;
  originalFilename: Scalars['String']['output'];
  startedAt: Maybe<Scalars['Date']['output']>;
  status: UploadStatus;
  subStatus: Maybe<UploadSubStatus>;
  url: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
};

export enum UploadStatus {
  Deleted = 'DELETED',
  Error = 'ERROR',
  UploadFinished = 'UPLOAD_FINISHED',
  UploadPending = 'UPLOAD_PENDING'
}

export enum UploadSubStatus {
  MetadataAnalyzedFailed = 'METADATA_ANALYZED_FAILED',
  MetadataAnalyzedSuccessfully = 'METADATA_ANALYZED_SUCCESSFULLY',
  MetadataAnalyzing = 'METADATA_ANALYZING'
}

export type UploadsFilterInput = {
  fileType: InputMaybe<Scalars['String']['input']>;
  folderId: InputMaybe<Scalars['String']['input']>;
  ids: InputMaybe<Array<Scalars['String']['input']>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<UploadsFilterInputType>;
};

export enum UploadsFilterInputType {
  ApiOnly = 'API_ONLY',
  WebOnly = 'WEB_ONLY'
}

export type UpsertEnhancedImageFeedbackInput = {
  allowSharing: InputMaybe<Scalars['Boolean']['input']>;
  comment: Scalars['String']['input'];
  email: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type UpsertWorkflowSettingsInput = {
  name: Scalars['String']['input'];
};

export type UpsertWorkflowTriggersInput = {
  triggers: Array<WorkflowTriggerInput>;
};

export type User = {
  __typename?: 'User';
  Profile: Maybe<Profile>;
  activeCampaignPreferences: Scalars['PrismaJson']['output'];
  activePlan: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOAuth: Scalars['Boolean']['output'];
  issuerId: Maybe<Scalars['String']['output']>;
  mustValidateUrgently: Scalars['Boolean']['output'];
  status: UserStatus;
  updatedAt: Scalars['Date']['output'];
  uploadRetentionDays: Maybe<Scalars['Int']['output']>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING',
  PendingForDeletion = 'PENDING_FOR_DELETION'
}

export type Webhook = {
  __typename?: 'Webhook';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  secret: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
};

export type WebhookLogsFilter = {
  skip: InputMaybe<Scalars['Int']['input']>;
  /** Use SUCCEEDED or FAILED to filter between statuses, leave empty to return both. */
  status: InputMaybe<WebhookResponseStatus>;
  take: InputMaybe<Scalars['Int']['input']>;
};

export type WebhookLogsPayload = {
  __typename?: 'WebhookLogsPayload';
  items: Array<WebhookResponseLog>;
  total: Scalars['Int']['output'];
};

export type WebhookResponseLog = {
  __typename?: 'WebhookResponseLog';
  createdAt: Scalars['Date']['output'];
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  responseBody: Scalars['String']['output'];
  responseStatusCode: Scalars['Int']['output'];
  status: WebhookResponseStatus;
  webhookData: Scalars['PrismaJson']['output'];
};

export enum WebhookResponseStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

export type Workflow = {
  __typename?: 'Workflow';
  Parameters: Maybe<WorkflowParameters>;
  Triggers: Array<WorkflowTrigger>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type WorkflowParameters = {
  __typename?: 'WorkflowParameters';
  artifactsDetectionRemoval: Maybe<EnhancedImageParametersArtifactsDetectionRemoval>;
  backgroundRemovalBlur: Maybe<Scalars['Decimal']['output']>;
  backgroundRemovalMode: Maybe<EnhancedImageParametersPortraitBackgroundMode>;
  backgroundRemovalReplaceImageUrl: Maybe<Scalars['String']['output']>;
  enhanceFaceDetails: Maybe<EnhancedImageParametersEnhanceFaceDetails>;
  id: Scalars['String']['output'];
  preset: Maybe<EnhancedImageParametersPreset>;
  upscalingCustomWidth: Maybe<Scalars['Int']['output']>;
  upscalingFactor: Maybe<EnhancedImageParametersUpscalingFactor>;
};

export type WorkflowTrigger = {
  __typename?: 'WorkflowTrigger';
  InputFolder: Maybe<Folder>;
  OutputFolder: Maybe<Folder>;
  Workflow: Workflow;
  id: Scalars['String']['output'];
};

export type WorkflowTriggerInput = {
  inputFolderId: Scalars['String']['input'];
  outputFolderId: Scalars['String']['input'];
};

export type WorkflowUpsertInput = {
  id: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  parameters: InputMaybe<WorkflowUpsertParametersInput>;
};

export type WorkflowUpsertParametersInput = {
  artifactsDetectionRemoval: InputMaybe<EnhancedImageParametersArtifactsDetectionRemoval>;
  backgroundRemovalBlur: InputMaybe<Scalars['Decimal']['input']>;
  backgroundRemovalMode: InputMaybe<EnhancedImageParametersPortraitBackgroundMode>;
  backgroundRemovalReplaceImageUrl: InputMaybe<Scalars['String']['input']>;
  enhanceFaceDetails: InputMaybe<EnhancedImageParametersEnhanceFaceDetails>;
  preset: InputMaybe<EnhancedImageParametersPreset>;
  upscalingCustomWidth: InputMaybe<Scalars['Int']['input']>;
  upscalingFactor: InputMaybe<EnhancedImageParametersUpscalingFactor>;
};

export type UploadFieldsFragment = { __typename?: 'Upload', id: string, url: string | null, filename: string, originalFilename: string, height: number, width: number, mimetype: string, startedAt: any | null, finishedAt: any | null, folderId: string | null, metadata: any | null, subStatus: UploadSubStatus | null, lastSuccesfulEnhancedImage: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null, lastSuccesfulEnhancedImagePreview: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null };

export type EnhancedImageFieldsFragment = { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } };

export type FolderFieldsFragment = { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> };

export type WorkflowFieldsFragment = { __typename?: 'Workflow', id: string, name: string, Triggers: Array<{ __typename?: 'WorkflowTrigger', id: string, InputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null, OutputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null }>, Parameters: { __typename?: 'WorkflowParameters', id: string, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null } | null };

export type AccountSubscriptionFieldsFragment = { __typename?: 'AccountSubscription', id: string, accountId: string, autoTopUpEnabled: boolean, autoTopUpLimit: number | null, stripeSubscriptionId: string | null };

export type PlanFieldsFragment = { __typename?: 'Plan', id: string, name: string, topUpPrice: number | null, topupCreditsAmount: number | null, monthlyPrice: number | null, monthlyCreditsAmount: number | null };

export type ApiKeyFieldsFragment = { __typename?: 'ApiKey', id: string | null, label: string | null, key: string | null };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { apiKeys: Array<{ __typename?: 'ApiKey', id: string | null, label: string | null, key: string | null }> };

export type CreateApiKeyMutationVariables = Exact<{
  label: Scalars['String']['input'];
}>;


export type CreateApiKeyMutation = { createApiKey: { __typename?: 'ApiKey', id: string | null, label: string | null, key: string | null } };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { deleteApiKey: boolean };

export type RefreshApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RefreshApiKeyMutation = { refreshApiKey: { __typename?: 'ApiKey', id: string | null, label: string | null, key: string | null } };

export type ApiKeysUsageQueryVariables = Exact<{
  apiKeyId: InputMaybe<Scalars['String']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiKeysUsageQuery = { apiKeysUsage: { __typename?: 'ApiKeysUsagePayload', _id: string, uploadsFinished: number, enhancementsCreated: number, creditsUsed: number, averageEnhancementDuration: number | null } };

export type UserFieldsFragment = { __typename?: 'User', email: string, id: string, status: UserStatus, mustValidateUrgently: boolean, isOAuth: boolean, activePlan: string, activeCampaignPreferences: any, Profile: { __typename?: 'Profile', id: string, avatarUrl: string | null, firstName: string | null, lastName: string | null, salutation: string | null, dateOfBirth: string | null, country: string | null, companyName: string | null, companyRole: string | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { __typename?: 'User', email: string, id: string, status: UserStatus, mustValidateUrgently: boolean, isOAuth: boolean, activePlan: string, activeCampaignPreferences: any, Profile: { __typename?: 'Profile', id: string, avatarUrl: string | null, firstName: string | null, lastName: string | null, salutation: string | null, dateOfBirth: string | null, country: string | null, companyName: string | null, companyRole: string | null } | null } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { updateProfile: { __typename?: 'User', email: string, id: string, status: UserStatus, mustValidateUrgently: boolean, isOAuth: boolean, activePlan: string, activeCampaignPreferences: any, Profile: { __typename?: 'Profile', id: string, avatarUrl: string | null, firstName: string | null, lastName: string | null, salutation: string | null, dateOfBirth: string | null, country: string | null, companyName: string | null, companyRole: string | null } | null } };

export type DeleteMeMutationVariables = Exact<{
  input: DeleteMeInput;
}>;


export type DeleteMeMutation = { deleteMe: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { updatePassword: boolean };

export type UpdateEmailAddressMutationVariables = Exact<{
  input: UpdateEmailAddressInput;
}>;


export type UpdateEmailAddressMutation = { updateEmailAddress: boolean };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { signup: boolean };

export type ConfirmSignupEmailAddressMutationVariables = Exact<{
  input: ConfirmSignupEmailAddressInput;
}>;


export type ConfirmSignupEmailAddressMutation = { confirmSignupEmailAddress: boolean };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { login: { __typename?: 'User', id: string, email: string } };

export type RequestResetPasswordMutationVariables = Exact<{
  input: RequestResetPasswordInput;
}>;


export type RequestResetPasswordMutation = { requestResetPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type ResendEmailConfirmationMutationVariables = Exact<{
  input: ResendEmailConfirmationInput;
}>;


export type ResendEmailConfirmationMutation = { resendEmailConfirmation: boolean };

export type ContactSupportMutationVariables = Exact<{
  input: ContactSupportInput;
}>;


export type ContactSupportMutation = { contactSupport: boolean };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { account: { __typename?: 'Account', id: string, isDemoContentReady: boolean, AccountSubscription: { __typename?: 'AccountSubscription', id: string, accountId: string, autoTopUpEnabled: boolean, autoTopUpLimit: number | null, stripeSubscriptionId: string | null, Plan: { __typename?: 'Plan', id: string, name: string, topUpPrice: number | null, topupCreditsAmount: number | null, monthlyPrice: number | null, monthlyCreditsAmount: number | null } }, stripeSubscription: { __typename?: 'StripeSubscription', currency: string | null, cancel_at_period_end: boolean, current_period_end: number, schedule: string | null } | null } | null };

export type CreditsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditsQuery = { credits: { __typename?: 'CreditsPayload', id: string, periodStart: any, periodEnd: any | null, totalCreditsInThisPeriod: number, usedCreditsThisPeriod: number, remainingCreditsThisPeriod: number | null, usedTopUps: number | null } };

export type CreateEnhancedImageMutationVariables = Exact<{
  uploadId: Scalars['String']['input'];
  input: CreateEnhancedImageInput;
}>;


export type CreateEnhancedImageMutation = { createEnhancedImage: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } };

export type CancelEnhancementMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelEnhancementMutation = { cancelEnhancement: string };

export type EnhancedImageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EnhancedImageQuery = { enhancedImage: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null };

export type EnhancedImageWithFeedbackQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EnhancedImageWithFeedbackQuery = { enhancedImage: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null };

export type EnhancedImageCompletedQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EnhancedImageCompletedQuery = { enhancedImageCompleted: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } };

export type UpsertEnhancedImageFeedbackMutationVariables = Exact<{
  enhancedImageId: Scalars['String']['input'];
  input: UpsertEnhancedImageFeedbackInput;
}>;


export type UpsertEnhancedImageFeedbackMutation = { upsertEnhancedImageFeedback: boolean };

export type CreateExportMutationVariables = Exact<{
  uploadIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateExportMutation = { createExport: { __typename?: 'CreateExportPayload', downloadUrl: string | null, filename: string | null, enhancedImagesCount: number, unEnhancedImagesCount: number, exportCreatedAsync: boolean } };

export type FoldersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<FoldersFilterInput>;
}>;


export type FoldersQuery = { folders: { __typename?: 'QueryFoldersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'QueryFoldersConnectionEdge', cursor: string, node: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } }> } };

export type WorkflowTriggerFieldsFragment = { __typename?: 'WorkflowTrigger', id: string, Workflow: { __typename?: 'Workflow', id: string, name: string } };

export type FolderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FolderQuery = { folder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string, Workflow: { __typename?: 'Workflow', id: string, name: string } }>, OutputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string, Workflow: { __typename?: 'Workflow', id: string, name: string } }> } | null, folderBreadcrumb: Array<{ __typename?: 'FolderBreadcrumbItem', id: string, name: string }> };

export type CreateFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateFolderMutation = { createFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } };

export type UpdateFolderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateFolderInput;
}>;


export type UpdateFolderMutation = { updateFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } };

export type DeleteFolderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteFolderMutation = { deleteFolder: boolean };

export type AnalyzePdfMutationVariables = Exact<{
  uploadId: Scalars['String']['input'];
}>;


export type AnalyzePdfMutation = { analyzePdf: { __typename?: 'AnalyzePdfRes', success: boolean } };

export type CreatePortalSessionMutationVariables = Exact<{
  input: CreatePortalSessionInput;
}>;


export type CreatePortalSessionMutation = { createPortalSession: { __typename?: 'CreatePortalSessionPayload', url: string } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionMutation = { createCheckoutSession: { __typename?: 'CreateCheckoutSessionPayload', url: string } };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { paymentMethods: { __typename?: 'PaymentMethodsPayload', items: Array<{ __typename?: 'PaymentMethod', card: { __typename?: 'PaymentMethodCard', last4: string | null, exp_month: number, exp_year: number, brand: string | null }, billing_details: { __typename?: 'PaymentMethodBillingDetails', name: string | null, address: { __typename?: 'PaymentMethodAddress', line1: string | null, line2: string | null, state: string | null, postal_code: string | null, country: string | null, city: string | null } } }> } };

export type InvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoicesQuery = { invoices: { __typename?: 'InvoicesPayload', hasMore: boolean, items: Array<{ __typename?: 'Invoice', id: string, number: string | null, status: InvoiceStatus, amount: number, currency: InvoiceCurrency, issuedAt: any, periodStartAt: any | null, periodEndAt: any | null, hostedInvoiceUrl: string | null, invoicePdfUrl: string | null, stripeSubscriptionId: string | null }> } };

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { cancelSubscription: boolean };

export type PlansQueryVariables = Exact<{
  currency: InputMaybe<Currency>;
}>;


export type PlansQuery = { plans: Array<{ __typename?: 'Plan', id: string, name: string, topUpPrice: number | null, topupCreditsAmount: number | null, monthlyPrice: number | null, monthlyCreditsAmount: number | null }> };

export type UpdateAccountSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
  input: UpdateAccountSubscriptionInput;
}>;


export type UpdateAccountSubscriptionMutation = { updateAccountSubscription: { __typename?: 'AccountSubscription', id: string, accountId: string, autoTopUpEnabled: boolean, autoTopUpLimit: number | null, stripeSubscriptionId: string | null } };

export type TasksListQueryVariables = Exact<{ [key: string]: never; }>;


export type TasksListQuery = { tasksList: { __typename?: 'TasksListPayload', _id: string, hash: string, inProgress: Array<{ __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } }>, completed: Array<{ __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } }> } };

export type CreateSignedUploadUrlMutationVariables = Exact<{
  input: CreateSignedUploadUrlInput;
}>;


export type CreateSignedUploadUrlMutation = { createSignedUploadUrl: { __typename?: 'CreateSignedUploadUrlPayload', uploadUrl: string, uploadId: string } };

export type CompleteSignedUploadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CompleteSignedUploadMutation = { completeSignedUpload: { __typename?: 'Upload', id: string, url: string | null, filename: string, originalFilename: string, height: number, width: number, mimetype: string, startedAt: any | null, finishedAt: any | null, folderId: string | null, metadata: any | null, subStatus: UploadSubStatus | null, lastSuccesfulEnhancedImage: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null, lastSuccesfulEnhancedImagePreview: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null } };

export type UploadsQueryVariables = Exact<{
  ids: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  folderId: InputMaybe<Scalars['String']['input']>;
  fileType: InputMaybe<Scalars['String']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<UploadsFilterInputType>;
}>;


export type UploadsQuery = { uploads: { __typename?: 'QueryUploadsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'QueryUploadsConnectionEdge', cursor: string, node: { __typename?: 'Upload', id: string, url: string | null, filename: string, originalFilename: string, height: number, width: number, mimetype: string, startedAt: any | null, finishedAt: any | null, folderId: string | null, metadata: any | null, subStatus: UploadSubStatus | null, lastSuccesfulEnhancedImage: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null, lastSuccesfulEnhancedImagePreview: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null } }> } };

export type UploadQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UploadQuery = { upload: { __typename?: 'Upload', id: string, url: string | null, filename: string, originalFilename: string, height: number, width: number, mimetype: string, startedAt: any | null, finishedAt: any | null, folderId: string | null, metadata: any | null, subStatus: UploadSubStatus | null, lastSuccesfulEnhancedImage: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null, lastSuccesfulEnhancedImagePreview: { __typename?: 'EnhancedImage', id: string, mode: EnhancedImageEnhancementMode, fullUrl: string | null, status: EnhancedImageStatus, viesusDuration: number | null, errorCode: string | null, uploadId: string, mimetype: string | null, EnhancedImageParameters: { __typename?: 'EnhancedImageParameters', id: string, defaultImageEnhancement: EnhancedImageParametersDefaultImageEnhancement | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, upscalingCustomDPI: number | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null, customColorConfig: any | null, noiseAdditionProfilingStrength: any | null, noiseReductionProfilingMode: EnhancedImageParametersNoiseReductionProfilingMode | null, noiseReductionProfilingMonochromeStrength: any | null, noiseReductionProfilingStrength: any | null, redEyeCorrectionsEyeStrength: any | null, redEyeCorrectionsMode: EnhancedImageParametersRedEyeCorrectionsMode | null, redEyeCorrectionsStrength: any | null, targetResolution: any | null, upscalingThreshold: any | null }, Workflow: { __typename?: 'Workflow', id: string, name: string } | null, EnhancedImageFeedback: { __typename?: 'EnhancedImageFeedback', id: string, score: number, comment: string } | null, Upload: { __typename?: 'Upload', id: string, mimetype: string, originalFilename: string } } | null } | null };

export type DeleteUploadsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteUploadsMutation = { deleteUploads: { __typename?: 'DeleteUploadsPayload', deletedUploadIds: Array<string> } };

export type WorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowsQuery = { workflows: { __typename?: 'QueryWorkflowsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'QueryWorkflowsConnectionEdge', node: { __typename?: 'Workflow', id: string, name: string, Triggers: Array<{ __typename?: 'WorkflowTrigger', id: string, InputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null, OutputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null }>, Parameters: { __typename?: 'WorkflowParameters', id: string, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null } | null } }> } };

export type WorkflowQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type WorkflowQuery = { workflow: { __typename?: 'Workflow', id: string, name: string, Triggers: Array<{ __typename?: 'WorkflowTrigger', id: string, InputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null, OutputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null }>, Parameters: { __typename?: 'WorkflowParameters', id: string, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null } | null } | null };

export type CreateWorkflowMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateWorkflowMutation = { upsertWorkflow: { __typename?: 'Workflow', id: string, name: string, Triggers: Array<{ __typename?: 'WorkflowTrigger', id: string, InputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null, OutputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null }>, Parameters: { __typename?: 'WorkflowParameters', id: string, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null } | null } };

export type UpsertWorkflowMutationVariables = Exact<{
  input: WorkflowUpsertInput;
}>;


export type UpsertWorkflowMutation = { upsertWorkflow: { __typename?: 'Workflow', id: string, name: string, Triggers: Array<{ __typename?: 'WorkflowTrigger', id: string, InputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null, OutputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null }>, Parameters: { __typename?: 'WorkflowParameters', id: string, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null } | null } };

export type DeleteWorkflowMutationVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;


export type DeleteWorkflowMutation = { deleteWorkflow: boolean };

export type UpdateWorkflowSettingsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpsertWorkflowSettingsInput;
}>;


export type UpdateWorkflowSettingsMutation = { updateWorkflowSettings: { __typename?: 'Workflow', id: string, name: string, Triggers: Array<{ __typename?: 'WorkflowTrigger', id: string, InputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null, OutputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null }>, Parameters: { __typename?: 'WorkflowParameters', id: string, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null } | null } };

export type UpsertWorkflowTriggersMutationVariables = Exact<{
  workflowId: Scalars['String']['input'];
  input: UpsertWorkflowTriggersInput;
}>;


export type UpsertWorkflowTriggersMutation = { upsertWorkflowTriggers: { __typename?: 'Workflow', id: string, name: string, Triggers: Array<{ __typename?: 'WorkflowTrigger', id: string, InputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null, OutputFolder: { __typename?: 'Folder', id: string, name: string, uploadsCount: number, parentFolderId: string | null, InputWorkflowTriggers: Array<{ __typename?: 'WorkflowTrigger', id: string }> } | null }>, Parameters: { __typename?: 'WorkflowParameters', id: string, upscalingFactor: EnhancedImageParametersUpscalingFactor | null, upscalingCustomWidth: number | null, backgroundRemovalMode: EnhancedImageParametersPortraitBackgroundMode | null, backgroundRemovalBlur: any | null, backgroundRemovalReplaceImageUrl: string | null, artifactsDetectionRemoval: EnhancedImageParametersArtifactsDetectionRemoval | null, enhanceFaceDetails: EnhancedImageParametersEnhanceFaceDetails | null, preset: EnhancedImageParametersPreset | null } | null } };

export const EnhancedImageFieldsFragmentDoc = gql`
    fragment EnhancedImageFields on EnhancedImage {
  id
  mode
  fullUrl
  status
  viesusDuration
  errorCode
  uploadId
  mimetype
  EnhancedImageParameters {
    id
    defaultImageEnhancement
    backgroundRemovalMode
    backgroundRemovalBlur
    backgroundRemovalReplaceImageUrl
    upscalingFactor
    upscalingCustomWidth
    upscalingCustomDPI
    artifactsDetectionRemoval
    enhanceFaceDetails
    preset
    customColorConfig
    noiseAdditionProfilingStrength
    noiseReductionProfilingMode
    noiseReductionProfilingMonochromeStrength
    noiseReductionProfilingStrength
    redEyeCorrectionsEyeStrength
    redEyeCorrectionsMode
    redEyeCorrectionsStrength
    targetResolution
    upscalingThreshold
  }
  Workflow {
    id
    name
  }
  EnhancedImageFeedback {
    id
    score
    comment
  }
  Upload {
    id
    mimetype
    originalFilename
  }
}
    `;
export const UploadFieldsFragmentDoc = gql`
    fragment UploadFields on Upload {
  id
  url
  filename
  originalFilename
  height
  width
  mimetype
  startedAt
  finishedAt
  folderId
  metadata
  subStatus
  lastSuccesfulEnhancedImage {
    ...EnhancedImageFields
  }
  lastSuccesfulEnhancedImagePreview {
    ...EnhancedImageFields
  }
}
    ${EnhancedImageFieldsFragmentDoc}`;
export const FolderFieldsFragmentDoc = gql`
    fragment FolderFields on Folder {
  id
  name
  uploadsCount
  parentFolderId
  InputWorkflowTriggers {
    id
  }
}
    `;
export const WorkflowFieldsFragmentDoc = gql`
    fragment WorkflowFields on Workflow {
  id
  name
  Triggers {
    id
    InputFolder {
      ...FolderFields
    }
    OutputFolder {
      ...FolderFields
    }
  }
  Parameters {
    id
    upscalingFactor
    upscalingCustomWidth
    backgroundRemovalMode
    backgroundRemovalBlur
    backgroundRemovalReplaceImageUrl
    artifactsDetectionRemoval
    enhanceFaceDetails
    preset
  }
}
    ${FolderFieldsFragmentDoc}`;
export const AccountSubscriptionFieldsFragmentDoc = gql`
    fragment AccountSubscriptionFields on AccountSubscription {
  id
  accountId
  autoTopUpEnabled
  autoTopUpLimit
  stripeSubscriptionId
}
    `;
export const PlanFieldsFragmentDoc = gql`
    fragment PlanFields on Plan {
  id
  name
  topUpPrice
  topupCreditsAmount
  monthlyPrice
  monthlyCreditsAmount
}
    `;
export const ApiKeyFieldsFragmentDoc = gql`
    fragment ApiKeyFields on ApiKey {
  id
  label
  key
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  email
  id
  status
  mustValidateUrgently
  isOAuth
  activePlan
  activeCampaignPreferences
  Profile {
    id
    avatarUrl
    firstName
    lastName
    salutation
    dateOfBirth
    country
    companyName
    companyRole
  }
}
    `;
export const WorkflowTriggerFieldsFragmentDoc = gql`
    fragment WorkflowTriggerFields on WorkflowTrigger {
  id
  Workflow {
    id
    name
  }
}
    `;
export const ApiKeysDocument = gql`
    query ApiKeys {
  apiKeys {
    ...ApiKeyFields
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($label: String!) {
  createApiKey(label: $label) {
    ...ApiKeyFields
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($id: String!) {
  deleteApiKey(id: $id)
}
    `;
export const RefreshApiKeyDocument = gql`
    mutation RefreshApiKey($id: String!) {
  refreshApiKey(id: $id) {
    ...ApiKeyFields
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export const ApiKeysUsageDocument = gql`
    query ApiKeysUsage($apiKeyId: String, $date: String) {
  apiKeysUsage(apiKeyId: $apiKeyId, date: $date) {
    _id
    uploadsFinished
    enhancementsCreated
    creditsUsed
    averageEnhancementDuration
  }
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const DeleteMeDocument = gql`
    mutation DeleteMe($input: DeleteMeInput!) {
  deleteMe(input: $input)
}
    `;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input)
}
    `;
export const UpdateEmailAddressDocument = gql`
    mutation UpdateEmailAddress($input: UpdateEmailAddressInput!) {
  updateEmailAddress(input: $input)
}
    `;
export const SignupDocument = gql`
    mutation Signup($input: SignupInput!) {
  signup(input: $input)
}
    `;
export const ConfirmSignupEmailAddressDocument = gql`
    mutation ConfirmSignupEmailAddress($input: ConfirmSignupEmailAddressInput!) {
  confirmSignupEmailAddress(input: $input)
}
    `;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    id
    email
  }
}
    `;
export const RequestResetPasswordDocument = gql`
    mutation RequestResetPassword($input: RequestResetPasswordInput!) {
  requestResetPassword(input: $input)
}
    `;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export const ResendEmailConfirmationDocument = gql`
    mutation ResendEmailConfirmation($input: ResendEmailConfirmationInput!) {
  resendEmailConfirmation(input: $input)
}
    `;
export const ContactSupportDocument = gql`
    mutation ContactSupport($input: ContactSupportInput!) {
  contactSupport(input: $input)
}
    `;
export const AccountDocument = gql`
    query Account {
  account {
    id
    isDemoContentReady
    AccountSubscription {
      ...AccountSubscriptionFields
      Plan {
        ...PlanFields
      }
    }
    stripeSubscription {
      currency
      cancel_at_period_end
      current_period_end
      schedule
    }
  }
}
    ${AccountSubscriptionFieldsFragmentDoc}
${PlanFieldsFragmentDoc}`;
export const CreditsDocument = gql`
    query Credits {
  credits {
    id
    periodStart
    periodEnd
    totalCreditsInThisPeriod
    usedCreditsThisPeriod
    remainingCreditsThisPeriod
    usedTopUps
  }
}
    `;
export const CreateEnhancedImageDocument = gql`
    mutation CreateEnhancedImage($uploadId: String!, $input: CreateEnhancedImageInput!) {
  createEnhancedImage(uploadId: $uploadId, input: $input) {
    ...EnhancedImageFields
  }
}
    ${EnhancedImageFieldsFragmentDoc}`;
export const CancelEnhancementDocument = gql`
    mutation CancelEnhancement($id: String!) {
  cancelEnhancement(id: $id)
}
    `;
export const EnhancedImageDocument = gql`
    query EnhancedImage($id: String!) {
  enhancedImage(id: $id) {
    ...EnhancedImageFields
  }
}
    ${EnhancedImageFieldsFragmentDoc}`;
export const EnhancedImageWithFeedbackDocument = gql`
    query EnhancedImageWithFeedback($id: String!) {
  enhancedImage(id: $id) {
    ...EnhancedImageFields
    EnhancedImageFeedback {
      id
      score
      comment
    }
  }
}
    ${EnhancedImageFieldsFragmentDoc}`;
export const EnhancedImageCompletedDocument = gql`
    query EnhancedImageCompleted($id: String!) {
  enhancedImageCompleted(id: $id) {
    ...EnhancedImageFields
  }
}
    ${EnhancedImageFieldsFragmentDoc}`;
export const UpsertEnhancedImageFeedbackDocument = gql`
    mutation UpsertEnhancedImageFeedback($enhancedImageId: String!, $input: UpsertEnhancedImageFeedbackInput!) {
  upsertEnhancedImageFeedback(enhancedImageId: $enhancedImageId, input: $input)
}
    `;
export const CreateExportDocument = gql`
    mutation CreateExport($uploadIds: [String!]!) {
  createExport(uploadIds: $uploadIds) {
    downloadUrl
    filename
    enhancedImagesCount
    unEnhancedImagesCount
    exportCreatedAsync
  }
}
    `;
export const FoldersDocument = gql`
    query Folders($first: Int!, $after: String, $filter: FoldersFilterInput) {
  folders(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        ...FolderFields
      }
    }
  }
}
    ${FolderFieldsFragmentDoc}`;
export const FolderDocument = gql`
    query Folder($id: String!) {
  folder(id: $id) {
    ...FolderFields
    InputWorkflowTriggers {
      ...WorkflowTriggerFields
    }
    OutputWorkflowTriggers {
      ...WorkflowTriggerFields
    }
  }
  folderBreadcrumb(id: $id) {
    id
    name
  }
}
    ${FolderFieldsFragmentDoc}
${WorkflowTriggerFieldsFragmentDoc}`;
export const CreateFolderDocument = gql`
    mutation CreateFolder($input: CreateFolderInput!) {
  createFolder(input: $input) {
    ...FolderFields
  }
}
    ${FolderFieldsFragmentDoc}`;
export const UpdateFolderDocument = gql`
    mutation UpdateFolder($id: String!, $input: UpdateFolderInput!) {
  updateFolder(id: $id, input: $input) {
    ...FolderFields
  }
}
    ${FolderFieldsFragmentDoc}`;
export const DeleteFolderDocument = gql`
    mutation DeleteFolder($id: String!) {
  deleteFolder(id: $id)
}
    `;
export const AnalyzePdfDocument = gql`
    mutation AnalyzePdf($uploadId: String!) {
  analyzePdf(uploadId: $uploadId) {
    success
  }
}
    `;
export const CreatePortalSessionDocument = gql`
    mutation CreatePortalSession($input: CreatePortalSessionInput!) {
  createPortalSession(input: $input) {
    url
  }
}
    `;
export const CreateCheckoutSessionDocument = gql`
    mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) {
  createCheckoutSession(input: $input) {
    url
  }
}
    `;
export const PaymentMethodsDocument = gql`
    query PaymentMethods {
  paymentMethods {
    items {
      card {
        last4
        exp_month
        exp_year
        brand
      }
      billing_details {
        name
        address {
          line1
          line2
          state
          postal_code
          country
          city
        }
      }
    }
  }
}
    `;
export const InvoicesDocument = gql`
    query Invoices {
  invoices {
    hasMore
    items {
      id
      number
      status
      amount
      currency
      issuedAt
      periodStartAt
      periodEndAt
      hostedInvoiceUrl
      invoicePdfUrl
      stripeSubscriptionId
    }
  }
}
    `;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input)
}
    `;
export const PlansDocument = gql`
    query Plans($currency: Currency) {
  plans(currency: $currency) {
    ...PlanFields
  }
}
    ${PlanFieldsFragmentDoc}`;
export const UpdateAccountSubscriptionDocument = gql`
    mutation UpdateAccountSubscription($subscriptionId: String!, $input: UpdateAccountSubscriptionInput!) {
  updateAccountSubscription(subscriptionId: $subscriptionId, input: $input) {
    ...AccountSubscriptionFields
  }
}
    ${AccountSubscriptionFieldsFragmentDoc}`;
export const TasksListDocument = gql`
    query TasksList {
  tasksList {
    _id
    hash
    inProgress {
      ...EnhancedImageFields
    }
    completed {
      ...EnhancedImageFields
    }
  }
}
    ${EnhancedImageFieldsFragmentDoc}`;
export const CreateSignedUploadUrlDocument = gql`
    mutation CreateSignedUploadUrl($input: CreateSignedUploadUrlInput!) {
  createSignedUploadUrl(input: $input) {
    uploadUrl
    uploadId
  }
}
    `;
export const CompleteSignedUploadDocument = gql`
    mutation CompleteSignedUpload($id: String!) {
  completeSignedUpload(id: $id) {
    ...UploadFields
  }
}
    ${UploadFieldsFragmentDoc}`;
export const UploadsDocument = gql`
    query Uploads($ids: [String!], $folderId: String, $fileType: String, $after: String, $first: Int, $type: UploadsFilterInputType) {
  uploads(
    after: $after
    first: $first
    filter: {ids: $ids, type: $type, folderId: $folderId, fileType: $fileType}
  ) {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        ...UploadFields
      }
    }
  }
}
    ${UploadFieldsFragmentDoc}`;
export const UploadDocument = gql`
    query Upload($id: String!) {
  upload(id: $id) {
    ...UploadFields
  }
}
    ${UploadFieldsFragmentDoc}`;
export const DeleteUploadsDocument = gql`
    mutation DeleteUploads($ids: [String!]!) {
  deleteUploads(ids: $ids) {
    deletedUploadIds
  }
}
    `;
export const WorkflowsDocument = gql`
    query Workflows {
  workflows {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        ...WorkflowFields
      }
    }
  }
}
    ${WorkflowFieldsFragmentDoc}`;
export const WorkflowDocument = gql`
    query Workflow($id: String!) {
  workflow(id: $id) {
    ...WorkflowFields
  }
}
    ${WorkflowFieldsFragmentDoc}`;
export const CreateWorkflowDocument = gql`
    mutation CreateWorkflow($name: String!) {
  upsertWorkflow(input: {name: $name}) {
    ...WorkflowFields
  }
}
    ${WorkflowFieldsFragmentDoc}`;
export const UpsertWorkflowDocument = gql`
    mutation UpsertWorkflow($input: WorkflowUpsertInput!) {
  upsertWorkflow(input: $input) {
    ...WorkflowFields
  }
}
    ${WorkflowFieldsFragmentDoc}`;
export const DeleteWorkflowDocument = gql`
    mutation DeleteWorkflow($workflowId: String!) {
  deleteWorkflow(workflowId: $workflowId)
}
    `;
export const UpdateWorkflowSettingsDocument = gql`
    mutation UpdateWorkflowSettings($id: String!, $input: UpsertWorkflowSettingsInput!) {
  updateWorkflowSettings(workflowId: $id, input: $input) {
    ...WorkflowFields
  }
}
    ${WorkflowFieldsFragmentDoc}`;
export const UpsertWorkflowTriggersDocument = gql`
    mutation UpsertWorkflowTriggers($workflowId: String!, $input: UpsertWorkflowTriggersInput!) {
  upsertWorkflowTriggers(workflowId: $workflowId, input: $input) {
    ...WorkflowFields
  }
}
    ${WorkflowFieldsFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ApiKeys(variables?: ApiKeysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ApiKeysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApiKeysQuery>({ document: ApiKeysDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ApiKeys', 'query', variables);
    },
    CreateApiKey(variables: CreateApiKeyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateApiKeyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateApiKeyMutation>({ document: CreateApiKeyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateApiKey', 'mutation', variables);
    },
    DeleteApiKey(variables: DeleteApiKeyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteApiKeyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteApiKeyMutation>({ document: DeleteApiKeyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteApiKey', 'mutation', variables);
    },
    RefreshApiKey(variables: RefreshApiKeyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RefreshApiKeyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshApiKeyMutation>({ document: RefreshApiKeyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RefreshApiKey', 'mutation', variables);
    },
    ApiKeysUsage(variables?: ApiKeysUsageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ApiKeysUsageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApiKeysUsageQuery>({ document: ApiKeysUsageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ApiKeysUsage', 'query', variables);
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>({ document: MeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Me', 'query', variables);
    },
    UpdateProfile(variables: UpdateProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProfileMutation>({ document: UpdateProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateProfile', 'mutation', variables);
    },
    DeleteMe(variables: DeleteMeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteMeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMeMutation>({ document: DeleteMeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteMe', 'mutation', variables);
    },
    UpdatePassword(variables: UpdatePasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdatePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePasswordMutation>({ document: UpdatePasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdatePassword', 'mutation', variables);
    },
    UpdateEmailAddress(variables: UpdateEmailAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateEmailAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEmailAddressMutation>({ document: UpdateEmailAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateEmailAddress', 'mutation', variables);
    },
    Signup(variables: SignupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignupMutation>({ document: SignupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Signup', 'mutation', variables);
    },
    ConfirmSignupEmailAddress(variables: ConfirmSignupEmailAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfirmSignupEmailAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmSignupEmailAddressMutation>({ document: ConfirmSignupEmailAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfirmSignupEmailAddress', 'mutation', variables);
    },
    Login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>({ document: LoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Login', 'mutation', variables);
    },
    RequestResetPassword(variables: RequestResetPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RequestResetPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestResetPasswordMutation>({ document: RequestResetPasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RequestResetPassword', 'mutation', variables);
    },
    ResetPassword(variables: ResetPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResetPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetPasswordMutation>({ document: ResetPasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResetPassword', 'mutation', variables);
    },
    ResendEmailConfirmation(variables: ResendEmailConfirmationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResendEmailConfirmationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendEmailConfirmationMutation>({ document: ResendEmailConfirmationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResendEmailConfirmation', 'mutation', variables);
    },
    ContactSupport(variables: ContactSupportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContactSupportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactSupportMutation>({ document: ContactSupportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ContactSupport', 'mutation', variables);
    },
    Account(variables?: AccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountQuery>({ document: AccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Account', 'query', variables);
    },
    Credits(variables?: CreditsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditsQuery>({ document: CreditsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Credits', 'query', variables);
    },
    CreateEnhancedImage(variables: CreateEnhancedImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateEnhancedImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEnhancedImageMutation>({ document: CreateEnhancedImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateEnhancedImage', 'mutation', variables);
    },
    CancelEnhancement(variables: CancelEnhancementMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CancelEnhancementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelEnhancementMutation>({ document: CancelEnhancementDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CancelEnhancement', 'mutation', variables);
    },
    EnhancedImage(variables: EnhancedImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EnhancedImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EnhancedImageQuery>({ document: EnhancedImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EnhancedImage', 'query', variables);
    },
    EnhancedImageWithFeedback(variables: EnhancedImageWithFeedbackQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EnhancedImageWithFeedbackQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EnhancedImageWithFeedbackQuery>({ document: EnhancedImageWithFeedbackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EnhancedImageWithFeedback', 'query', variables);
    },
    EnhancedImageCompleted(variables: EnhancedImageCompletedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EnhancedImageCompletedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EnhancedImageCompletedQuery>({ document: EnhancedImageCompletedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EnhancedImageCompleted', 'query', variables);
    },
    UpsertEnhancedImageFeedback(variables: UpsertEnhancedImageFeedbackMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpsertEnhancedImageFeedbackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertEnhancedImageFeedbackMutation>({ document: UpsertEnhancedImageFeedbackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpsertEnhancedImageFeedback', 'mutation', variables);
    },
    CreateExport(variables: CreateExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateExportMutation>({ document: CreateExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateExport', 'mutation', variables);
    },
    Folders(variables: FoldersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FoldersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FoldersQuery>({ document: FoldersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Folders', 'query', variables);
    },
    Folder(variables: FolderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FolderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FolderQuery>({ document: FolderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Folder', 'query', variables);
    },
    CreateFolder(variables: CreateFolderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateFolderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFolderMutation>({ document: CreateFolderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateFolder', 'mutation', variables);
    },
    UpdateFolder(variables: UpdateFolderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateFolderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFolderMutation>({ document: UpdateFolderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateFolder', 'mutation', variables);
    },
    DeleteFolder(variables: DeleteFolderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteFolderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFolderMutation>({ document: DeleteFolderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteFolder', 'mutation', variables);
    },
    AnalyzePdf(variables: AnalyzePdfMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnalyzePdfMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalyzePdfMutation>({ document: AnalyzePdfDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnalyzePdf', 'mutation', variables);
    },
    CreatePortalSession(variables: CreatePortalSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreatePortalSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePortalSessionMutation>({ document: CreatePortalSessionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreatePortalSession', 'mutation', variables);
    },
    CreateCheckoutSession(variables: CreateCheckoutSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateCheckoutSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCheckoutSessionMutation>({ document: CreateCheckoutSessionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateCheckoutSession', 'mutation', variables);
    },
    PaymentMethods(variables?: PaymentMethodsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentMethodsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentMethodsQuery>({ document: PaymentMethodsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PaymentMethods', 'query', variables);
    },
    Invoices(variables?: InvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesQuery>({ document: InvoicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Invoices', 'query', variables);
    },
    CancelSubscription(variables: CancelSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CancelSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelSubscriptionMutation>({ document: CancelSubscriptionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CancelSubscription', 'mutation', variables);
    },
    Plans(variables?: PlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlansQuery>({ document: PlansDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Plans', 'query', variables);
    },
    UpdateAccountSubscription(variables: UpdateAccountSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateAccountSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccountSubscriptionMutation>({ document: UpdateAccountSubscriptionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateAccountSubscription', 'mutation', variables);
    },
    TasksList(variables?: TasksListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TasksListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TasksListQuery>({ document: TasksListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TasksList', 'query', variables);
    },
    CreateSignedUploadUrl(variables: CreateSignedUploadUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateSignedUploadUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSignedUploadUrlMutation>({ document: CreateSignedUploadUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateSignedUploadUrl', 'mutation', variables);
    },
    CompleteSignedUpload(variables: CompleteSignedUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CompleteSignedUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteSignedUploadMutation>({ document: CompleteSignedUploadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CompleteSignedUpload', 'mutation', variables);
    },
    Uploads(variables?: UploadsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UploadsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadsQuery>({ document: UploadsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Uploads', 'query', variables);
    },
    Upload(variables: UploadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UploadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadQuery>({ document: UploadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Upload', 'query', variables);
    },
    DeleteUploads(variables: DeleteUploadsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteUploadsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUploadsMutation>({ document: DeleteUploadsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteUploads', 'mutation', variables);
    },
    Workflows(variables?: WorkflowsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkflowsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkflowsQuery>({ document: WorkflowsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Workflows', 'query', variables);
    },
    Workflow(variables: WorkflowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkflowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkflowQuery>({ document: WorkflowDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Workflow', 'query', variables);
    },
    CreateWorkflow(variables: CreateWorkflowMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateWorkflowMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWorkflowMutation>({ document: CreateWorkflowDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateWorkflow', 'mutation', variables);
    },
    UpsertWorkflow(variables: UpsertWorkflowMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpsertWorkflowMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertWorkflowMutation>({ document: UpsertWorkflowDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpsertWorkflow', 'mutation', variables);
    },
    DeleteWorkflow(variables: DeleteWorkflowMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteWorkflowMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWorkflowMutation>({ document: DeleteWorkflowDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteWorkflow', 'mutation', variables);
    },
    UpdateWorkflowSettings(variables: UpdateWorkflowSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateWorkflowSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWorkflowSettingsMutation>({ document: UpdateWorkflowSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateWorkflowSettings', 'mutation', variables);
    },
    UpsertWorkflowTriggers(variables: UpsertWorkflowTriggersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpsertWorkflowTriggersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertWorkflowTriggersMutation>({ document: UpsertWorkflowTriggersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpsertWorkflowTriggers', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;